(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isMobile = window.matchMedia(theme.mediaQueries.sm).matches;
        // console.log(isLargeScreen)
        const isConfirmNewsletter =
          !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.disclosure.open = isLargeScreen || isConfirmNewsletter;
        } else {
          this.disclosure.open = true;
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Start Logo Animation
  document.addEventListener('DOMContentLoaded', function () {
    var logo = document.querySelector('.header__logo');
    var scrollThreshold = 100;

    if (logo) {
      window.addEventListener(
        'scroll',
        function () {
          var scrolled = window.scrollY || document.documentElement.scrollTop;

          if (scrolled > scrollThreshold) {
            // Scrolled down > 100px: Add class to HIDE (slide up)
            logo.classList.add('is-hidden');
          } else {
            // Scrolled to top: Remove class to SHOW (slide down)
            logo.classList.remove('is-hidden');
          }
        },
        { passive: true }
      ); // Performance optimization
    }
  });
  // End Logo Animation

  if (!customElements.get('nav-menu')) {
    customElements.define(
      'nav-menu',
      class NavMenu extends HTMLElement {
        constructor() {
          super();
          this.details = this.querySelector('details');
          this.summary = this.querySelector('summary');
          this.toggleLink = this.summary.querySelector('.root-level-link');

          this.onBodyClick = this.onBodyClick.bind(this);
          this.onLinkClick = this.onLinkClick.bind(this);

          if (this.toggleLink) {
            this.toggleLink.addEventListener('click', this.onLinkClick);
          }

          document.addEventListener('click', this.onBodyClick);
        }

        onLinkClick(event) {
          if (window.matchMedia('(min-width: 990px)').matches) {
            event.preventDefault();
            event.stopPropagation();
            this.toggleMenu();
          }
        }

        toggleMenu() {
          const isOpen = this.details.hasAttribute('open');

          if (isOpen) {
            this.close();
          } else {
            // Check if we are switching from another menu
            // closeOthers now returns TRUE if it actually closed something
            const isSwitching = this.closeOthers();
            this.open(isSwitching);
          }
        }

        open(isInstant = false) {
          this.details.setAttribute('open', '');

          if (isInstant) {
            // 1. INSTANT OPEN (Switching)
            // We add the class immediately. Since the element was just added to DOM,
            // the browser renders it at 1fr immediately without transitioning from 0fr.
            this.classList.add('menu-is-open');
          } else {
            // 2. ANIMATED OPEN (Fresh Click)
            // We wait a tiny bit (10ms) so the browser renders 0fr first,
            // then we add the class to trigger the transition to 1fr.
            setTimeout(() => {
              this.classList.add('menu-is-open');
            }, 10);
          }

          if (this.toggleLink) {
            this.toggleLink.classList.add('active-menu');
          }
          document.body.classList.add('overflow-hidden');
        }

        close() {
          this.classList.remove('menu-is-open');

          if (this.toggleLink) {
            this.toggleLink.classList.remove('active-menu');
          }

          // Wait for CSS transition (0.2s) to finish before removing from DOM
          setTimeout(() => {
            // Only remove 'open' if we haven't re-opened it (race condition check)
            if (!this.classList.contains('menu-is-open')) {
              this.details.removeAttribute('open');
            }

            // Manage body scroll
            if (!document.querySelector('nav-menu details[open]')) {
              document.body.classList.remove('overflow-hidden');
            }
          }, 300);
        }

        closeOthers() {
          let closedSomething = false;

          document.querySelectorAll('nav-menu details[open]').forEach((details) => {
            if (details !== this.details) {
              const navMenu = details.closest('nav-menu');
              if (navMenu) {
                // Remove styling immediately
                navMenu.classList.remove('menu-is-open');

                // Remove active class
                const otherLink = navMenu.querySelector('.root-level-link');
                if (otherLink) {
                  otherLink.classList.remove('active-menu');
                }

                // Remove open attribute immediately (Snap close the old one)
                details.removeAttribute('open');

                closedSomething = true;
              }
            }
          });

          return closedSomething;
        }

        onBodyClick(event) {
          if (!this.contains(event.target) && this.details.hasAttribute('open')) {
            if (window.matchMedia('(min-width: 990px)').matches) {
              this.close();
            }
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
